export const CHALLENGE = "ONBOARDEDAIIIIIIIIIIIIIIIIIIIIIIIIIIIII"